/* global requirejs */
import {
  asosGlobalNamespace,
  manifestWindowKey,
  featureManifestWindowKey
} from "../../template/constants";

const getVersionManifestFeatures = () => {
  if (
    window[asosGlobalNamespace][manifestWindowKey] &&
    window[asosGlobalNamespace][manifestWindowKey].features
  ) {
    const features = window[asosGlobalNamespace][manifestWindowKey].features;
    delete window[asosGlobalNamespace][manifestWindowKey].features;
    return features;
  }
};

const getFeatureManifest = () =>
  window[asosGlobalNamespace][featureManifestWindowKey] ||
  /* backward compatibility */ window.__featureManifest || {
    features: {},
    mvt: {}
  };

export const initialise = context =>
  new Promise(resolve => {
    requirejs(["asos-web-features"], ({ default: features }) => {
      const instance = features.getInstance(getFeatureManifest(), context);
      resolve(instance);
    });
  });

export const addManifestFeatures = instance =>
  instance.addManifest({ features: getVersionManifestFeatures() });
